interface IconProps {
  className?: string
}

const iconBase = "w-20 h-20 sm:w-24 sm:h-24"

export function CatalogIcon({ className = iconBase }: IconProps) {
  return (
    <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <circle cx="60" cy="60" r="56" fill="#005288" />
      {/* Open book */}
      <rect x="30" y="40" width="28" height="38" rx="2" fill="white" />
      <rect x="62" y="40" width="28" height="38" rx="2" fill="#D6E8F2" />
      <line x1="58" y1="38" x2="58" y2="80" stroke="white" strokeWidth="2" />
      {/* Text lines */}
      <rect x="35" y="48" width="18" height="2.5" rx="1" fill="#C0C2C4" />
      <rect x="35" y="54" width="15" height="2.5" rx="1" fill="#C0C2C4" />
      <rect x="35" y="60" width="17" height="2.5" rx="1" fill="#C0C2C4" />
      <rect x="67" y="48" width="18" height="2.5" rx="1" fill="#4A97C9" />
      <rect x="67" y="54" width="15" height="2.5" rx="1" fill="#4A97C9" />
      <rect x="67" y="60" width="17" height="2.5" rx="1" fill="#4A97C9" />
      {/* Search magnifier */}
      <circle cx="80" cy="35" r="10" fill="#5E9732" />
      <circle cx="78" cy="33" r="5" stroke="white" strokeWidth="1.5" fill="none" />
      <line x1="82" y1="37" x2="86" y2="41" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )
}

export function TrainingIcon({ className = iconBase }: IconProps) {
  return (
    <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <circle cx="60" cy="60" r="56" fill="#005288" />
      {/* Monitor */}
      <rect x="28" y="30" width="64" height="44" rx="4" fill="#003a5c" />
      <rect x="32" y="34" width="56" height="34" rx="2" fill="#D6E8F2" />
      {/* Play button */}
      <circle cx="60" cy="51" r="12" fill="#5E9732" />
      <polygon points="56,44 56,58 68,51" fill="white" />
      {/* Monitor stand */}
      <rect x="50" y="74" width="20" height="4" rx="1" fill="#003a5c" />
      <rect x="44" y="78" width="32" height="4" rx="2" fill="#003a5c" />
      {/* Progress bar */}
      <rect x="36" y="62" width="48" height="3" rx="1.5" fill="white" />
      <rect x="36" y="62" width="30" height="3" rx="1.5" fill="#5E9732" />
    </svg>
  )
}

export function TranscriptIcon({ className = iconBase }: IconProps) {
  return (
    <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <circle cx="60" cy="60" r="56" fill="#005288" />
      {/* Document */}
      <rect x="35" y="25" width="50" height="65" rx="3" fill="white" />
      {/* Header line */}
      <rect x="43" y="33" width="34" height="4" rx="2" fill="#003a5c" />
      {/* Content lines */}
      <rect x="43" y="43" width="30" height="2.5" rx="1" fill="#C0C2C4" />
      <rect x="43" y="49" width="25" height="2.5" rx="1" fill="#C0C2C4" />
      <rect x="43" y="55" width="28" height="2.5" rx="1" fill="#C0C2C4" />
      <rect x="43" y="61" width="22" height="2.5" rx="1" fill="#C0C2C4" />
      {/* Checkmark seal */}
      <circle cx="60" cy="78" r="9" fill="#5E9732" />
      <path d="M55 78 L58 81 L65 74" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function DashboardIcon({ className = iconBase }: IconProps) {
  return (
    <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <circle cx="60" cy="60" r="56" fill="#005288" />
      {/* Dashboard panel */}
      <rect x="28" y="32" width="64" height="50" rx="4" fill="white" />
      {/* Chart bars */}
      <rect x="36" y="62" width="8" height="14" rx="1" fill="#4A97C9" />
      <rect x="48" y="52" width="8" height="24" rx="1" fill="#5E9732" />
      <rect x="60" y="56" width="8" height="20" rx="1" fill="#4A97C9" />
      <rect x="72" y="46" width="8" height="30" rx="1" fill="#5E9732" />
      {/* Top stat boxes */}
      <rect x="34" y="36" width="22" height="10" rx="2" fill="#D6E8F2" />
      <rect x="62" y="36" width="22" height="10" rx="2" fill="#D6E8F2" />
      {/* Arrow up */}
      <path d="M82 85 L86 80 L90 85" stroke="#5E9732" strokeWidth="2" strokeLinecap="round" fill="none" />
      <line x1="86" y1="80" x2="86" y2="90" stroke="#5E9732" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}

export function FeedbackIcon({ className = iconBase }: IconProps) {
  return (
    <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <circle cx="60" cy="60" r="56" fill="#005288" />
      {/* Chat bubble */}
      <rect x="30" y="32" width="52" height="38" rx="6" fill="white" />
      <polygon points="45,70 50,80 58,70" fill="white" />
      {/* Text lines in bubble */}
      <rect x="38" y="42" width="36" height="3" rx="1.5" fill="#C0C2C4" />
      <rect x="38" y="49" width="28" height="3" rx="1.5" fill="#C0C2C4" />
      <rect x="38" y="56" width="32" height="3" rx="1.5" fill="#C0C2C4" />
      {/* Small reply bubble */}
      <rect x="60" y="60" width="32" height="22" rx="5" fill="#D6E8F2" />
      <rect x="66" y="67" width="20" height="2.5" rx="1" fill="#4A97C9" />
      <rect x="66" y="73" width="15" height="2.5" rx="1" fill="#4A97C9" />
    </svg>
  )
}

export function ExportIcon({ className = iconBase }: IconProps) {
  return (
    <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <circle cx="60" cy="60" r="56" fill="#005288" />
      {/* File/document */}
      <rect x="35" y="30" width="40" height="52" rx="3" fill="white" />
      <rect x="42" y="38" width="26" height="3" rx="1.5" fill="#003a5c" />
      <rect x="42" y="46" width="22" height="2.5" rx="1" fill="#C0C2C4" />
      <rect x="42" y="52" width="24" height="2.5" rx="1" fill="#C0C2C4" />
      <rect x="42" y="58" width="18" height="2.5" rx="1" fill="#C0C2C4" />
      {/* Export arrow */}
      <circle cx="78" cy="72" r="14" fill="#5E9732" />
      <path d="M78 79 L78 66" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
      <path d="M73 70 L78 65 L83 70" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  )
}
